// extracted by css-extract-rspack-plugin
export default {"icon":"_4c74e2f4"};